import React from "react";
import Style from "./Sidebar.module.css";
import "./side.css";
import logo from "../../images/logo512-removebg-preview.png";
import { Link, useLocation } from "react-router-dom";
const Sidebar = (props) => {
  const location = useLocation();
  const maindClass =
    location.pathname == "/" ||
    location.pathname == "/subject" ||
    location.pathname == "/Videos"
      ? "active"
      : "";
  const userClass =
    location.pathname == "/My_subscriptions" ||
    location.pathname == "/My_subscriptions/Subject" ||
    location.pathname == "/My_subscriptions/Videos" ||
    location.pathname == "/My_subscriptions/VideoDetails"
      ? "active"
      : "";
  const ExamClass = location.pathname == "/My_exams" ? "active" : "";
  const SupportClass = location.pathname == "/Support" ? "active" : "";
  const ComplaintsClass =
    location.pathname == "/My_Complaints" ||
    location.pathname == "/My_Complaints/ComplaintsDetails" ||
    location.pathname == "/My_Complaints/NewComplaints"
      ? "active"
      : "";
  //   const  = location.pathname.match(/^\/user/) ? "active" : "";
  //   const listClass = location.pathname.match(/^\/list/) ? "active" : "";

  return (
    <>
      <aside className="flex flex-col fixed right-0  z-50  sideContant w-20 h-screen pb-8 overflow-y-auto border-r rtl:border-l rtl:border-r-0 bg-gray-50">
        <nav className="flex flex-col flex-1 space-y-5 ">
          <Link
            to={"/"}
            className="p-1.5  aside flex flex-col items-center justify-center text-gray-700 focus:outline-none transition-colors duration-200 rounded-lg "
          >
            <img src={logo} alt="" className="w-20 rounded-full" />
          </Link>

          <Link
            to={"/"}
            className={`${maindClass} px-1.5 py-1 flex flex-col items-center justify-center text-gray-700 focus:outline-none transition-colors duration-200 rounded-lg  hover:bg-green-400`}
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="22.5"
                cy="22.5"
                r="21.5"
                stroke={maindClass == "active" ? "#009539" : "#ECECEC"}
                fill={maindClass == "active" ? "" : "#ECECEC"}
              />
              <path
                d="M22.9987 10C22.7629 10 22.5283 10.0875 22.336 10.2628L11.1201 20.4864C10.9788 20.6159 10.9592 20.845 11.0772 20.9992C11.1965 21.1534 11.4059 21.1742 11.5472 21.0447L22.7591 10.8239C22.8985 10.6966 23.1002 10.6966 23.2396 10.8239L34.4528 21.0461C34.5148 21.1028 34.591 21.1299 34.6663 21.1299C34.7617 21.1299 34.8568 21.0865 34.9228 21.0007C35.0408 20.8465 35.0212 20.6166 34.8799 20.4878L32.9997 18.7747V13.6352C32.9997 13.2337 32.701 12.9078 32.3331 12.9078H31.6664C31.2984 12.9078 30.9998 13.2337 30.9998 13.6352V16.9507L23.6627 10.2628C23.4704 10.0875 23.2345 10 22.9987 10ZM23 11.5555L13.0003 20.6697V31.8181C13.0003 33.0232 13.8956 34 15.0002 34H30.4998C31.8804 34 32.9997 32.7788 32.9997 31.2726V20.6697L23 11.5555ZM20.7774 23.8176H25.2213C25.8353 23.8176 26.3332 24.3609 26.3332 25.0307V33.2727H19.6668V25.0307C19.6668 24.3609 20.1641 23.8176 20.7774 23.8176Z"
                fill="#009539"
              />
            </svg>

            <p
              style={
                maindClass == "active"
                  ? { fontSize: "14px", color: "#009539", fontWeight: "bold" }
                  : { fontSize: "14px" }
              }
              className=""
            >
              الرئيسيه
            </p>
          </Link>

          <Link
            to={"/My_subscriptions"}
            className="px-1.5 py-1 flex flex-col items-center justify-center text-gray-700 focus:outline-none transition-colors duration-200 rounded-lg  hover:bg-green-400"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="22.5"
                cy="22.5"
                r="21.5"
                stroke={userClass == "active" ? "#009539" : "#ECECEC"}
                fill={userClass == "active" ? "" : "#ECECEC"}
              />
              <circle cx="22" cy="22" r="15" fill="#F4A922" />
              <path
                d="M18.8009 12.8333H25.1992C25.4119 12.8333 25.5751 12.8333 25.7181 12.8471C26.7337 12.947 27.5651 13.5575 27.9181 14.3798H16.0821C16.435 13.5575 17.2664 12.947 18.2821 12.8471C18.4232 12.8333 18.5864 12.8333 18.8009 12.8333ZM16.7842 15.3294C15.5101 15.3294 14.4651 16.0994 14.1167 17.1206C14.1091 17.1419 14.1018 17.1633 14.0947 17.1848C14.4596 17.0748 14.84 17.0014 15.2241 16.9528C16.2141 16.8254 17.4662 16.8254 18.9201 16.8254H25.2377C26.6916 16.8254 27.9428 16.8254 28.9337 16.9528C29.3187 17.0023 29.6982 17.0738 30.0631 17.1848C30.0564 17.1632 30.0494 17.1419 30.042 17.1206C29.6936 16.0994 28.6486 15.3294 27.3736 15.3294H16.7842Z"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.0506 17.9135H18.9493C15.8565 17.9135 14.3091 17.9135 13.4401 18.8182C12.5711 19.723 12.7756 21.12 13.1853 23.9149L13.5721 26.5659C13.893 28.7577 14.0534 29.854 14.8756 30.5103C15.6988 31.1667 16.9106 31.1667 19.3371 31.1667H24.6629C27.0884 31.1667 28.3021 31.1667 29.1243 30.5103C29.9466 29.854 30.107 28.7577 30.4278 26.5659L30.8146 23.9158C31.2244 21.12 31.4288 19.723 30.5598 18.8182C29.6908 17.9135 28.1435 17.9135 25.0506 17.9135ZM24.3659 25.4778C24.8783 25.1607 24.8783 24.3393 24.3659 24.0222L21.2758 22.1063C20.7781 21.7974 20.1666 22.1989 20.1666 22.8342V26.6658C20.1666 27.3011 20.7781 27.7017 21.2758 27.3937L24.3659 25.4778Z"
                fill="white"
              />
            </svg>
            <p
              style={
                userClass == "active"
                  ? { fontSize: "14px", color: "#009539", fontWeight: "bold" }
                  : { fontSize: "14px" }
              }
              className=""
            >
              اشتراكاتي
            </p>
          </Link>
          <Link
            to={"/My_exams"}
            className="px-1.5 py-1 flex flex-col items-center justify-center text-gray-700 focus:outline-none transition-colors duration-200 rounded-lg  hover:bg-green-400"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="22.5"
                cy="22.5"
                r="21.5"
                stroke={ExamClass == "active" ? "#009539" : "#ECECEC"}
                fill={ExamClass == "active" ? "" : "#ECECEC"}
              />
              <circle cx="23" cy="23" r="17" fill="#38AF9F" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M31.3333 16.8889C30.8913 16.8889 30.4674 17.0645 30.1548 17.377C29.8423 17.6896 29.6667 18.1135 29.6667 18.5556V19.6667H33V18.5556C33 18.1135 32.8244 17.6896 32.5118 17.377C32.1993 17.0645 31.7754 16.8889 31.3333 16.8889ZM33 20.7778H29.6667V29.9444L31.3333 32.4444L33 29.9444V20.7778ZM13 14.6667V31.3333C13 31.7754 13.1756 32.1993 13.4882 32.5118C13.8007 32.8244 14.2246 33 14.6667 33H26.8889C27.3309 33 27.7548 32.8244 28.0674 32.5118C28.38 32.1993 28.5556 31.7754 28.5556 31.3333V14.6667C28.5556 14.2246 28.38 13.8007 28.0674 13.4882C27.7548 13.1756 27.3309 13 26.8889 13H14.6667C14.2246 13 13.8007 13.1756 13.4882 13.4882C13.1756 13.8007 13 14.2246 13 14.6667ZM20.7778 18C20.7778 17.8527 20.8363 17.7113 20.9405 17.6072C21.0447 17.503 21.186 17.4444 21.3333 17.4444H25.7778C25.9251 17.4444 26.0664 17.503 26.1706 17.6072C26.2748 17.7113 26.3333 17.8527 26.3333 18C26.3333 18.1473 26.2748 18.2887 26.1706 18.3928C26.0664 18.497 25.9251 18.5556 25.7778 18.5556H21.3333C21.186 18.5556 21.0447 18.497 20.9405 18.3928C20.8363 18.2887 20.7778 18.1473 20.7778 18ZM21.3333 19.6667C21.186 19.6667 21.0447 19.7252 20.9405 19.8294C20.8363 19.9336 20.7778 20.0749 20.7778 20.2222C20.7778 20.3696 20.8363 20.5109 20.9405 20.6151C21.0447 20.7192 21.186 20.7778 21.3333 20.7778H25.7778C25.9251 20.7778 26.0664 20.7192 26.1706 20.6151C26.2748 20.5109 26.3333 20.3696 26.3333 20.2222C26.3333 20.0749 26.2748 19.9336 26.1706 19.8294C26.0664 19.7252 25.9251 19.6667 25.7778 19.6667H21.3333ZM20.7778 25.2222C20.7778 25.0749 20.8363 24.9336 20.9405 24.8294C21.0447 24.7252 21.186 24.6667 21.3333 24.6667H25.7778C25.9251 24.6667 26.0664 24.7252 26.1706 24.8294C26.2748 24.9336 26.3333 25.0749 26.3333 25.2222C26.3333 25.3696 26.2748 25.5109 26.1706 25.6151C26.0664 25.7192 25.9251 25.7778 25.7778 25.7778H21.3333C21.186 25.7778 21.0447 25.7192 20.9405 25.6151C20.8363 25.5109 20.7778 25.3696 20.7778 25.2222ZM21.3333 26.8889C21.186 26.8889 21.0447 26.9474 20.9405 27.0516C20.8363 27.1558 20.7778 27.2971 20.7778 27.4444C20.7778 27.5918 20.8363 27.7331 20.9405 27.8373C21.0447 27.9415 21.186 28 21.3333 28H25.7778C25.9251 28 26.0664 27.9415 26.1706 27.8373C26.2748 27.7331 26.3333 27.5918 26.3333 27.4444C26.3333 27.2971 26.2748 27.1558 26.1706 27.0516C26.0664 26.9474 25.9251 26.8889 25.7778 26.8889H21.3333ZM16.3333 25.2222V26.8889H18V25.2222H16.3333ZM15.7778 24.1111H18.5556C18.7029 24.1111 18.8442 24.1696 18.9484 24.2738C19.0526 24.378 19.1111 24.5193 19.1111 24.6667V27.4444C19.1111 27.5918 19.0526 27.7331 18.9484 27.8373C18.8442 27.9415 18.7029 28 18.5556 28H15.7778C15.6304 28 15.4891 27.9415 15.3849 27.8373C15.2808 27.7331 15.2222 27.5918 15.2222 27.4444V24.6667C15.2222 24.5193 15.2808 24.378 15.3849 24.2738C15.4891 24.1696 15.6304 24.1111 15.7778 24.1111ZM19.5039 18.3928C19.6051 18.288 19.6611 18.1477 19.6598 18.002C19.6586 17.8563 19.6001 17.717 19.4971 17.614C19.3941 17.511 19.2548 17.4526 19.1091 17.4513C18.9634 17.45 18.8231 17.506 18.7183 17.6072L16.8889 19.4367L16.1706 18.7183C16.0658 18.6171 15.9254 18.5611 15.7798 18.5624C15.6341 18.5637 15.4948 18.6221 15.3918 18.7251C15.2888 18.8281 15.2303 18.9674 15.2291 19.1131C15.2278 19.2588 15.2838 19.3991 15.385 19.5039L16.8889 21.0078L19.5039 18.3928Z"
                fill="white"
              />
            </svg>

            <p
              style={
                ExamClass == "active"
                  ? {
                      fontSize: "14px",
                      color: "#009539",
                      fontWeight: "bold",
                      textAlign: "center",
                    }
                  : { fontSize: "14px", textAlign: "center" }
              }
              className=""
            >
              {" "}
              الاختبارات المحلوله
            </p>
          </Link>
          <Link
            to={"/My_Complaints"}
            className="px-1.5 py-1 flex flex-col items-center justify-center text-gray-700 focus:outline-none transition-colors duration-200 rounded-lg  hover:bg-green-400"
          >
            <svg
              width="40"
              height="40"
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="22.5"
                cy="22.5"
                r="21.5"
                stroke={ComplaintsClass == "active" ? "#009539" : "#ECECEC"}
                fill={ComplaintsClass == "active" ? "" : "#ECECEC"}
              />
              <path
                d="M37.8744 27.0126C37.875 27.1148 37.8554 27.2162 37.8166 27.3109C37.7779 27.4056 37.7208 27.4917 37.6486 27.5642C37.5765 27.6367 37.4907 27.6942 37.3962 27.7334C37.3017 27.7726 37.2004 27.7928 37.0982 27.7927L33.2093 27.8028C33.1073 27.803 33.0062 27.7831 32.9119 27.7442C32.8176 27.7053 32.7319 27.6483 32.6597 27.5763C32.5874 27.5042 32.5301 27.4187 32.4909 27.3245C32.4518 27.2303 32.4316 27.1293 32.4315 27.0273C32.4309 26.9252 32.4504 26.824 32.489 26.7294C32.5276 26.6348 32.5845 26.5488 32.6564 26.4763C32.7283 26.4037 32.8138 26.3461 32.908 26.3066C33.0022 26.2672 33.1032 26.2467 33.2054 26.2464L37.0943 26.2363C37.1965 26.236 37.2977 26.2559 37.3923 26.2947C37.4868 26.3336 37.5727 26.3907 37.6452 26.4628C37.7176 26.5349 37.7752 26.6205 37.8145 26.7149C37.8538 26.8092 37.8742 26.9103 37.8744 27.0126ZM36.64 22.7433C36.6839 22.8357 36.7092 22.9357 36.7144 23.0378C36.7195 23.1399 36.7045 23.242 36.6702 23.3383C36.6359 23.4346 36.583 23.5232 36.5144 23.599C36.4458 23.6748 36.363 23.7363 36.2706 23.7801L32.7574 25.4484C32.5708 25.5367 32.3568 25.5473 32.1624 25.4778C31.9681 25.4083 31.8093 25.2644 31.721 25.0778C31.6327 24.8913 31.6221 24.6772 31.6916 24.4829C31.7612 24.2885 31.905 24.1297 32.0916 24.0414L35.604 22.3739C35.7904 22.2855 36.0043 22.2748 36.1986 22.3441C36.3928 22.4133 36.5516 22.557 36.64 22.7433ZM36.661 31.2888C36.7487 31.1021 36.7586 30.8882 36.6886 30.6943C36.6186 30.5003 36.4744 30.342 36.2877 30.2543L32.7667 28.6039C32.6738 28.5563 32.5722 28.528 32.468 28.5206C32.3639 28.5131 32.2593 28.5267 32.1606 28.5605C32.0618 28.5944 31.9708 28.6477 31.8931 28.7174C31.8154 28.7872 31.7525 28.8718 31.7082 28.9664C31.6639 29.0609 31.6391 29.1634 31.6353 29.2677C31.6315 29.3721 31.6487 29.4761 31.6859 29.5737C31.7231 29.6712 31.7796 29.7603 31.852 29.8355C31.9243 29.9108 32.0111 29.9707 32.1072 30.0117L35.6274 31.6629C35.8141 31.7502 36.0278 31.7599 36.2216 31.6897C36.4154 31.6196 36.5735 31.4754 36.661 31.2888Z"
                fill="#FA743E"
              />
              <path
                d="M31.7617 20.5694C30.6572 20.2436 29.6671 19.3662 29.3225 18.8194C28.7314 17.8799 29.4447 17.6364 29.2035 15.0169C28.9819 12.619 25.6802 10.0399 21.6669 9.77778C19.8422 9.65878 17.9444 10.0313 16 11.0946C11.0067 13.8253 9.02798 19.5972 12.8842 25.1716C16.3609 30.196 13.0989 32.4663 13.0989 32.4663C13.0989 32.4663 13.228 33.5241 15.3653 34.9459C17.5034 36.3669 20.1261 35.4032 20.1261 35.4032C20.1261 35.4032 20.991 32.3279 23.819 32.611C25.8459 32.9097 28.6925 32.5107 29.412 31.8146C30.0848 31.1636 29.2945 30.3477 29.8312 28.5292C27.9918 28.3488 26.9807 27.4722 26.8834 26.2363C28.9251 26.4347 29.7674 25.7868 30.3508 25.0736C30.3344 24.6536 30.2924 23.7622 30.252 23.1649C32.058 22.6422 32.7502 20.8611 31.7617 20.5694Z"
                fill="#226699"
              />
            </svg>
            <p
              style={
                ComplaintsClass == "active"
                  ? {
                      fontSize: "14px",
                      color: "#009539",
                      fontWeight: "bold",
                      textAlign: "center",
                    }
                  : { fontSize: "14px", textAlign: "center" }
              }
              className=""
            >
              الشكاوي
            </p>
          </Link>
          <Link
            to={"/Support"}
            className="px-1.5 py-1 flex flex-col items-center justify-center text-gray-700 focus:outline-none transition-colors duration-200 rounded-lg  hover:bg-green-400"
          >
            <svg
              width="40"
              height="45"
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="22.5"
                cy="22.5"
                r="21.5"
                stroke={SupportClass == "active" ? "#009539" : "#ECECEC"}
                fill={SupportClass == "active" ? "" : "#ECECEC"}
              />
              <path
                d="M22 14.1249C20.097 14.1253 18.2368 14.6898 16.6545 15.7471C15.0722 16.8044 13.8389 18.3071 13.1103 20.0651C12.3818 21.8232 12.1907 23.7577 12.5613 25.6243C12.932 27.4909 13.8476 29.2058 15.1925 30.5521C15.4385 30.7986 15.5765 31.1327 15.5762 31.4809C15.5758 31.8291 15.4372 32.1629 15.1908 32.4089C14.9443 32.6549 14.6102 32.7929 14.262 32.7926C13.9138 32.7922 13.58 32.6536 13.334 32.4071C11.6219 30.6935 10.4563 28.5107 9.98457 26.1348C9.51281 23.7588 9.75605 21.2963 10.6835 19.0586C11.611 16.8208 13.1812 14.9083 15.1954 13.5627C17.2097 12.2172 19.5777 11.499 22 11.499C24.4224 11.499 26.7903 12.2172 28.8046 13.5627C30.8188 14.9083 32.389 16.8208 33.3165 19.0586C34.244 21.2963 34.4872 23.7588 34.0154 26.1348C33.5437 28.5107 32.3781 30.6935 30.666 32.4071C30.545 32.5326 30.4002 32.6326 30.2401 32.7015C30.08 32.7703 29.9078 32.8066 29.7335 32.8082C29.5593 32.8098 29.3864 32.7767 29.2251 32.7108C29.0638 32.6448 28.9172 32.5475 28.7939 32.4243C28.6706 32.3011 28.5731 32.1546 28.507 31.9933C28.4409 31.8321 28.4076 31.6593 28.4091 31.485C28.4105 31.3107 28.4466 31.1385 28.5153 30.9783C28.584 30.8181 28.684 30.6733 28.8093 30.5521C30.1543 29.2057 31.0699 27.4907 31.4405 25.6239C31.8111 23.7572 31.6199 21.8224 30.8911 20.0643C30.1624 18.3062 28.9287 16.8036 27.3462 15.7464C25.7636 14.6892 23.9032 14.1249 22 14.1249ZM22 21.1249C21.3038 21.1249 20.6361 21.4014 20.1439 21.8937C19.6516 22.386 19.375 23.0537 19.375 23.7499C19.375 24.4461 19.6516 25.1138 20.1439 25.606C20.6361 26.0983 21.3038 26.3749 22 26.3749C22.6962 26.3749 23.3639 26.0983 23.8562 25.606C24.3484 25.1138 24.625 24.4461 24.625 23.7499C24.625 23.0537 24.3484 22.386 23.8562 21.8937C23.3639 21.4014 22.6962 21.1249 22 21.1249ZM17.1875 23.7499C17.1875 22.9586 17.3826 22.1795 17.7555 21.4817C18.1284 20.7838 18.6677 20.1886 19.3255 19.7489C19.9833 19.3091 20.7394 19.0383 21.5269 18.9606C22.3143 18.8828 23.1088 19.0003 23.8399 19.3028C24.5711 19.6054 25.2164 20.0835 25.7187 20.6949C26.2209 21.3064 26.5647 22.0322 26.7195 22.8082C26.8743 23.5842 26.8354 24.3863 26.6062 25.1437C26.377 25.901 25.9646 26.5902 25.4055 27.1501C25.1595 27.3966 25.0215 27.7307 25.0218 28.0789C25.0222 28.4271 25.1608 28.7609 25.4073 29.0069C25.6537 29.2529 25.9878 29.3909 26.336 29.3906C26.6842 29.3902 27.018 29.2516 27.264 29.0051C28.303 27.9645 29.0102 26.6393 29.2963 25.1969C29.5824 23.7544 29.4344 22.2596 28.8711 20.9012C28.3079 19.5429 27.3546 18.3819 26.1318 17.5652C24.9089 16.7485 23.4714 16.3126 22.0009 16.3126C20.5304 16.3126 19.0929 16.7485 17.87 17.5652C16.6472 18.3819 15.6939 19.5429 15.1306 20.9012C14.5674 22.2596 14.4194 23.7544 14.7055 25.1969C14.9915 26.6393 15.6987 27.9645 16.7378 29.0051C16.8579 29.1341 17.0028 29.2375 17.1638 29.3093C17.3248 29.381 17.4986 29.4196 17.6748 29.4227C17.8511 29.4258 18.0261 29.3934 18.1896 29.3274C18.353 29.2613 18.5014 29.1631 18.6261 29.0385C18.7507 28.9138 18.849 28.7654 18.915 28.6019C18.981 28.4385 19.0134 28.2635 19.0103 28.0872C19.0072 27.911 18.9686 27.7372 18.8969 27.5762C18.8251 27.4152 18.7217 27.2703 18.5928 27.1501C18.1461 26.7039 17.7921 26.1737 17.5509 25.5902C17.3097 25.0067 17.1862 24.3813 17.1875 23.7499Z"
                fill="#AB2195"
              />
            </svg>

            <p
              style={
                SupportClass == "active"
                  ? {
                      fontSize: "14px",
                      color: "#009539",
                      fontWeight: "bold",
                      textAlign: "center",
                    }
                  : { fontSize: "14px", textAlign: "center" }
              }
              className=""
            >
              {" "}
              التواصل
            </p>
          </Link>
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
